<script>
import { ICONS } from '@modules/atendimento/constants/Text'
import ConexaoQrcodeAnimatedSvg from '@modules/atendimento/components/conexao-qrcode-animated-svg/conexao-qrcode-animated-svg.vue'
import { CONEXAO_CTA_TYPE } from '@modules/atendimento/utils/conexao-status-message'

export default {
  name: 'ChatWindowEmptyState',
  components: {
    ConexaoQrcodeAnimatedSvg,
  },
  props: {
    conexaoCta: {
      type: Object,
      default() {
        return { type: null, title: '', description: '' }
      },
    },
    canSendMessage: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      icons: ICONS,
      ctaTypes: CONEXAO_CTA_TYPE,
      tutorialMenuActive: false,
    }
  },
  methods: {
    onStartNovaConversa() {
      this.$emit('start-nova-conversa')
    },
  },
}
</script>

<template>
  <div
    v-if="conexaoCta && conexaoCta.type"
    data-test="conexao-cta-empty"
    class="chat-window__empty d-flex flex-column align-center justify-center flex-grow-1 px-6"
  >
    <icon-svg
      :name="icons.chatOutline"
      size="64"
      color="#8E8E8E"
      class="mb-4"
    />
    <span
      class="az-text-primary az-size-16 font-medium az-muted"
      data-test="conexao-cta-title"
    >
      {{ conexaoCta.title }}
    </span>
    <span
      class="az-text-small text-center mt-1 chat-window__empty-hint"
      data-test="conexao-cta-description"
    >
      {{ conexaoCta.description }}
    </span>
    <router-link
      v-if="conexaoCta.type === ctaTypes.CONFIG"
      :to="{ name: 'settings-v2.atendimento.conexoes' }"
      class="az-text-small mt-4"
      style="color: var(--primary)"
      data-test="conexao-cta-config-link"
    >
      Ir para Configurações
    </router-link>
    <v-menu
      v-else-if="conexaoCta.type === ctaTypes.SCAN_QRCODE"
      v-model="tutorialMenuActive"
      max-width="640"
      top
      open-on-hover
      :close-on-content-click="false"
    >
      <template v-slot:activator="{ on }">
        <span
          class="cursor-help d-inline-flex align-center az-text-small mt-3"
          style="color: var(--primary)"
          v-on="on"
        >
          <icon-svg
            name="mdi-information"
            size="14"
            color="var(--primary)"
            class="mr-1"
          />
          Ver tutorial passo a passo
        </span>
      </template>
      <div class="az-card pa-4">
        <span class="az-text-small">
          Clique no menu de ações <b>⋮</b> no topo da lista de conversas e
          selecione <b>Conectar via QR Code</b>. Um modal abrirá com o código
          para pareamento no WhatsApp.
        </span>
        <v-divider class="my-3" />
        <ConexaoQrcodeAnimatedSvg />
      </div>
    </v-menu>
  </div>

  <div
    v-else
    data-test="no-conversation-selected"
    class="chat-window__empty d-flex flex-column align-center justify-center flex-grow-1 px-6"
  >
    <icon-svg
      :name="icons.chatOutline"
      size="64"
      color="#8E8E8E"
      class="mb-4"
    />
    <span class="az-text-primary az-size-16 font-medium az-muted">
      Selecione ou inicie uma conversa
    </span>
    <span class="az-text-small text-center mt-1 chat-window__empty-hint">
      Escolha uma das conversas ao lado, ou toque em
      <strong>"Nova Conversa"</strong>
      no topo da lista para começar uma conversa com qualquer número.
    </span>
    <BaseButton
      primary
      class="mt-4"
      min-width="200px"
      :disabled="!canSendMessage"
      @click="onStartNovaConversa"
    >
      +
      <span class="ml-1">Nova Conversa</span>
    </BaseButton>
  </div>
</template>

<style lang="sass" scoped>
.chat-window__empty
  background-color: var(--panel-bg)

.chat-window__empty-hint
  color: var(--az-muted)
  max-width: 360px

.cursor-help
  cursor: help
</style>
